import React from "react";
import { IconCheckCircle, IconExclamationCircle } from '@paro.io/base-icons';
import { Box } from '@material-ui/core';

interface AlertBoxProps {
  title?: string;
  message?: string | JSX.Element;
  variant?: 'success' | 'warning' | 'info';
  showIcon?: boolean;
}

const AlertBox: React.FC<AlertBoxProps> = ({ title, message, variant = 'info', showIcon = true }) => {
  const colors = {
    success: { bg: '#A3DCD8', border: '#248384', text: '#0A433F' },
    warning: { bg: '#FFF3CD', border: '#F6A904', text: '#856404' },
    info: { bg: '#FFFFE9', border: '#F6A904', text: '#0A433F' },
  };

  const color = colors[variant];

  const icon = {
    success: <IconCheckCircle size="lg" className="text-success-dark mr-2" />,
    warning: <IconExclamationCircle size="md" className="text-warning mr-2" />,
    info: <IconExclamationCircle size="md" className="text-warning mr-2" />,
  };

  return (
    <Box
      sx={{
        marginTop: 20,
        marginBottom: 20,
        width: '100%',
        bgcolor: color.bg,
        border: `1px solid ${color.border}`,
        borderRadius: '16px',
        padding: 16,
        color: color.text,
      }}
    >
      <div className="flex items-start">
        {showIcon && icon[variant]}
        <div>
          {title && <p className="font-bold text-lg mb-2">{title}</p>}
          {message && <p>{message}</p>}
        </div>
      </div>
    </Box>
  );
};
export default AlertBox;